import { convertFileToBase64 } from "../../utils/getBase64";
import { LICENSE } from "./staticData";

const mapUiToData = async (data, nationality, id, ownerPlateNumber, isTruckOwner) => ({
    data: {
        ...(id && { id }),
        type: "drivers",
        attributes: {
            name: data?.name,
            email: data?.email,
            ...(data?.phoneNumber && { phoneNumber: `+2${data?.phoneNumber}` }),
            nationalId: data?.nationalId,
            ...(data?.supplier?.value && { supplierId: data?.supplier?.value }),
            ...(data?.supplier?.length && {
                supplierIds: data?.supplier?.map((supplier) => supplier?.value),
            }),
            workingGovernorates: data?.workingGovernorates?.map((el) => +el?.value),
            workingTruckTypes: data.truckTypes?.map((el) => el?.value),
            ownedTrucks: isTruckOwner ? [ownerPlateNumber?.value] : [],
            nationality: nationality?.value,
            ...(nationality?.value !== "egyptian" && {
                passportNumber: data?.passportNumber,
            }),
            ...(nationality?.value === "egyptian"
                ? { nationalIdExpiryDate: data?.idExpiryDate }
                : { passportExpiryDate: data?.idExpiryDate }),
            licenseExpiryDate: data?.licenseExpiryDate,
            ...(id
                ? (data?.drivingLicenseType?.value || data?.drivingLicenseType === null) && {
                      licenseType: data?.drivingLicenseType?.value || data?.drivingLicenseType,
                  }
                : { licenseType: data?.drivingLicenseType?.value }),
            notes: data?.notes,
            ...((!id || (id && data?.driverLicense?.length > 0)) && {
                driverLicense:
                    data?.driverLicense?.[0] &&
                    (await convertFileToBase64(data?.driverLicense?.[0])),
            }),
            ...((!id || (id && data?.photo?.length > 0)) && {
                photo: data?.photo?.[0] && (await convertFileToBase64(data?.photo?.[0])),
            }),

            ...((!id || (id && data?.nationalIdFace?.length > 0)) &&
                nationality?.value === "egyptian" && {
                    nationalIdFace:
                        data?.nationalIdFace?.[0] &&
                        (await convertFileToBase64(data?.nationalIdFace?.[0])),
                }),
            ...((!id || (id && data?.nationalIdBack?.length > 0)) &&
                nationality?.value === "egyptian" && {
                    nationalIdBack:
                        data?.nationalIdBack?.[0] &&
                        (await convertFileToBase64(data?.nationalIdBack?.[0])),
                }),
            ...((!id || (id && data?.passport?.length > 0)) &&
                nationality?.value !== "egyptian" && {
                    passport:
                        data?.passport?.[0] && (await convertFileToBase64(data.passport?.[0])),
                }),
        },
        /** payment method relationship is required and without it -> request will raise error */
        relationships: {
            ...(data?.methodType?.value && {
                paymentMethod: {
                    data: {
                        type: "paymentMethod",
                        attributes: {
                            methodType: data?.methodType?.value,
                            eWalletNumber: data?.eWalletNumber,
                            eWalletType: data?.eWalletType?.value,
                            bankName: data?.bankName?.label,
                            bankIban: data?.bankIban,
                            bankAccountNumber: data?.bankAccountNumber,
                            mezzaCardType: data?.mezzaCardType?.label,
                            mezzaCardNumber: data?.mezzaCardNumber,
                            accountHolderName: data?.accountHolderName,
                        },
                    },
                },
            }),
        },
    },
});
export const mapDrivertoUi = (fetchedData) => {
    // collecting data returened form the API 
    const attr = fetchedData?.data?.attributes;
    const included = fetchedData?.included;
    let data = { supplier: [] };
    const ownedTrucksId = included
        ?.filter((item) => item?.type === "trucks")
        ?.map((item) => item?.id);
    const ownedPlateNumber = included
        ?.filter((item) => item?.type === "trucks")
        ?.map((item) => item?.attributes?.plateNumber);
    Object.assign(data, attr);
    for (let i = 0; i < included?.length; i++) {
        if (included[i]?.type === "suppliers") {
            const supliers = { label: included[i]?.attributes?.name, value: included[i]?.id };

            data = { ...data, supplier: [...data?.supplier, supliers] };
        }
        if (included[i]?.type === "paymentMethods") {
            Object.assign(data, {
                paymentMethod: included[i]?.attributes,
            });
        }
    }
    const attachments = included?.map((item) => {
        if (item?.type === "attachments") {
            return { ...item?.attributes, id: item?.id };
        }
    });
    return {
        id: fetchedData?.data?.id,
        name: data?.name,
        email: data?.email,
        phoneNumber: data?.phoneNumber.substring(2),
        nationalId: data?.nationalId,
        idExpiryDate:
            data?.nationality === "egyptian"
                ? data?.nationalIdExpiryDate
                : data?.passportExpiryDate,
        passportNumber: data?.passportNumber,
        licenseExpiryDate: data?.licenseExpiryDate,
        drivingLicenseType: LICENSE.find((obj) => obj.value === data?.licenseType),
        workingGovernorates: data?.workingGovernorates?.map((item) => ({
            label: item?.name,
            value: item?.id,
        })),
        truckTypes: data?.truckTypes?.map((item) => ({ value: item, label: item })),
        nationality: { label: data?.nationality, value: data?.nationality },
        supplier: data?.supplier,
        bankAccountNumber: data?.paymentMethod?.bankAccountNumber,
        accountHolderName: data?.paymentMethod?.accountHolderName,
        bankIban: data?.paymentMethod?.bankIban,
        bankName: {
            label: data?.paymentMethod?.bankName,
            value: data?.paymentMethod?.bankName,
        },
        eWalletNumber: data?.paymentMethod?.eWalletNumber,
        eWalletType: {
            label: data?.paymentMethod?.eWalletType,
            value: data?.paymentMethod?.eWalletType,
        },
        methodType: {
            label: data?.paymentMethod?.methodType,
            value: data?.paymentMethod?.methodType,
        },
        mezzaCardNumber: data?.paymentMethod?.mezzaCardNumber,
        mezzaCardType: {
            label: data?.paymentMethod?.mezzaCardType,
            value: data?.paymentMethod?.mezzaCardType,
        },
        notes: data?.notes,
        qaStatus: data?.qaStatus,
        isTruckOwner: ownedTrucksId?.length > 0,
        ownerPlateNumber: {
            label: ownedPlateNumber,
            value: ownedTrucksId,
        },
    };
};
export default mapUiToData;
